<template>
  <v-container fluid>
    <v-row class="d-flex">
      <v-col cols="12" sm="12" md="6" lg="8" class="d-flex">
        <Scale />
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="4" class="d-flex">
        <Birthdays />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Birthdays from './components/Birthdays'
import Scale from '../scales/components/Scale.vue'
export default {
  name: 'Home',
  components: {
    Birthdays,
    Scale,
  },
}
</script>
